import { useCallback, useEffect, useRef } from 'react'

export default (id, disabled) => {
	const timerRef = useRef(null)

	const handleToggle = useCallback(event => {
		const lastTime = timerRef.current

		if (!lastTime) {
			return
		}
		switch (event.type) {
			case 'focus': {
				lastTime.lastPoint = +new Date()
				lastTime.paused = false
				break
			}
			case 'blur': {
				lastTime.spent += +new Date() - lastTime.lastPoint
				lastTime.paused = true
				break
			}
			default:
				break
		}
	}, [])

	const getTime = useCallback(() => {
		const lastTime = timerRef.current

		if (!lastTime) {
			return 0
		}

		return Math.round((lastTime.spent + (lastTime.paused ? 0 : +new Date() - lastTime.lastPoint)) / 1000)
	}, [])

	useEffect(() => {
		if (disabled) return undefined
		window.addEventListener('focus', handleToggle)
		window.addEventListener('blur', handleToggle)
		return () => {
			window.removeEventListener('focus', handleToggle)
			window.removeEventListener('blur', handleToggle)
		}
	}, [disabled, handleToggle])

	useEffect(() => {
		timerRef.current = disabled
			? null
			: {
					spent: 0,
					lastPoint: +new Date(),
					paused: false,
			  }
	}, [disabled, id])

	return getTime
}
